import { render, staticRenderFns } from "./configStatusColors.vue?vue&type=template&id=661ca831&scoped=true"
import script from "./configStatusColors.vue?vue&type=script&lang=js"
export * from "./configStatusColors.vue?vue&type=script&lang=js"
import style0 from "./configStatusColors.vue?vue&type=style&index=0&id=661ca831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ca831",
  null
  
)

export default component.exports